const ctr_pt = {
  loc_n: { x: 0, y: 0 },
};
const get_ctr = function (search_arr) {
  let aggt_loc_n = { x: 0, y: 0 }; // aggt means aggregate
  search_arr.forEach((s) => {
    aggt_loc_n.x += s.loc.norm.x;
    aggt_loc_n.y += s.loc.norm.y;
  });
  ctr_pt.loc_n.x = aggt_loc_n.x / search_arr.length;
  ctr_pt.loc_n.y = aggt_loc_n.y / search_arr.length;

  return ctr_pt.loc_n;
};

export { get_ctr };
